<section class="sas-sign-user d-flex flex-column align-items-end fw-bold">
  @if (isLogged) {
  <div class="user d-flex gap-1">
    <i class="bi bi-person-fill" aria-hidden="true"></i>
    <span class="username">{{username}}</span>
  </div>
  <a class="link-button" tabindex="0" (click)="signout()" [routerLink]="[clientUrl + '/landpage']">{{ signOutText | translate }}</a>
  }
  @else {
  <a class="link-button" [routerLink]="[clientUrl + '/signIn']">{{ signInText | translate }}</a>
  }
</section>
